import {h, Fragment} from "preact"
import { useEffect } from "preact/hooks";
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import {matchHeights} from "../helpers"

export default function Products() {
    const {
        products,
        loading,
        pageType,
        query
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading, pageType: state.pageType, query: state.query }))

    useEffect(()=>{
        if(pageType === "search"){
            const nativeQuantityElement = document.querySelector(".search-header__title");
            if(nativeQuantityElement){
                nativeQuantityElement.textContent = `${products?.total} results for "${query?.query}"`;
            }
        }

    }, [products])

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-serp .ns-link',
            priceElement: '.ns-serp .ns-price',
            listPriceElement: '.ns-serp .ns-list-price',
        })
    }, [ products?.hits ])

    useEffect(()=>{
        matchHeights(".ns-serp .product-item__meta");
    }, [products])

    // console.log(products);

    return (
        <div class="collection__products collection__infinite-container ns-products-list" 
        // style={loading ? "opacity: 0.3;" : ""}
        >
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} productZindex={products?.hits?.length - index} index={index} />
            })}
        </div>
    )
}
